<template>
  <div class="family-wrap">
    <CommonHead
      title="我的家庭"
      :cancel-type="1"
      @onCancel="onCancel"
    ></CommonHead>
    <van-pull-refresh
      class="content"
      v-model="refreshing"
      @refresh="onRefresh"
      style="min-height: calc(100vh - 97px)"
    >
      <!-- <van-list v-model="loading" :finished="finished" finished-text="下拉刷新家庭成员信息" @load="onLoad"> -->
      <div v-if="list.length > 0">
        <van-radio-group v-model="vaccId">
          <div
            :class="['family', { currFamily: !item.isGranted }]"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="radiofamily" v-if="idEdit">
              <van-radio :name="item.id" @click="delChange(item.id)" />
            </div>
            <div class="family-right">
              <div class="family-top">
                <div class="topleft">
                  <b>{{ item.name }}</b>
                  <img
                    :class="item.gender == '男' ? 'seximg' : 'imgwoman'"
                    :src="
                      item.gender == '男'
                        ? require('@/assets/user/man.png')
                        : require('@/assets/user/woman.png')
                    "
                  />
                  <span v-if="item.age == 0">{{ item.monthAge }}月龄</span>
                  <span v-else-if="0 < item.age && item.age < 2"
                    >{{ item.age }}岁{{ item.monthAge }}月龄</span
                  >
                  <span v-else>{{ item.age }}岁</span>
                  <van-tag
                    :color="
                      item.relation == '本人'
                        ? '#E5F1FF'
                        : item.relation == '子女'
                        ? '#FFE9EC'
                        : '#FFE1C4'
                    "
                    :text-color="
                      item.relation == '本人'
                        ? '#50A0FF'
                        : item.relation == '子女'
                        ? '#ED6071'
                        : '#FF884D'
                    "
                    size="medium"
                  >
                    {{ item.relation }}
                  </van-tag>
                  <van-tag
                    v-if="item.relation == '亲属' && item.isGranted == false"
                    plain
                    color="#AA23FF"
                    text-color="#AA23FF"
                    size="medium"
                  >
                    待授权
                  </van-tag>
                  <van-tag
                    v-if="item.relation == '子女' && item.verify != 1"
                    plain
                    color="#50C3FF"
                    text-color="#50C3FF"
                    size="medium"
                    >待认证</van-tag
                  >
                </div>
                <img
                  class="codeimg"
                  src="@/assets/user/code.png"
                  @click="QRcode(item.newCardNo)"
                  v-if="item.newCardNo"
                />
                <img
                  v-else
                  class="codeimg"
                  src="@/assets/user/code.png"
                  @click="QRcode(item.profileCode)"
                />
              </div>
              <div class="listdsc">档案单位 &nbsp;&nbsp;{{ item.povName }}</div>
              <div class="family-bot" v-if="item.isGranted">
                <van-button
                  round
                  block
                  type="default"
                  size="small"
                  @click="onDetail(item.id)"
                  >档案详情</van-button
                >
                <van-button
                  round
                  block
                  type="info"
                  size="small"
                  @click="onCheck"
                  >循证医学</van-button
                >
              </div>
            </div>
          </div>
        </van-radio-group>
      </div>

      <!-- </van-list> -->
      <van-empty description="暂无数据" v-if="list.length == 0" />
    </van-pull-refresh>

    <div class="family-list-bottom">
      <van-button round block type="info" @click="onAdd"
        >添加家庭成员</van-button
      >
    </div>

    <div class="fill-iphone-safe-area"></div>
    <van-dialog
      v-model="isshow"
      title="个案二维码信息"
      width="80%"
      confirmButtonText="关闭"
    >
      <!-- <img src="https://img01.yzcdn.cn/vant/apple-3.jpg" /> -->
      <qrcode
        :value="profileQrCode"
        :options="{ width: 196, scale: 4, small: true, margin: 1 }"
      ></qrcode>
    </van-dialog>
    <van-dialog
      v-model="isDel"
      title="是否确定删除该家庭成员？"
      show-cancel-button
      @confirm="sureDel"
      @cancel="cancle"
    >
    </van-dialog>
  </div>
</template>
<script>
import CommonHead from "components/CommonHead";
import computingAge from "utils/computingAge";
import {
  fetchFamily,
  delFamilyRecord,
  getQRcode,
  onloadFamily,
} from "api/user";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import moment from "moment";
import { Toast } from "vant";
import getAgeDesc from "utils/getAgeDesc";

export default {
  name: "",
  components: {
    CommonHead,
    qrcode: VueQrcode,
  },
  data() {
    return {
      refreshing: false,
      finished: false,
      loading: false,
      list: [],
      vaccId: "",
      idEdit: false,
      id: "",
      isshow: false,
      profileQrCode: "",
      isDel: false,
    };
  },
  created() {
    this.getFamilyList();
  },
  methods: {
    delChange(val) {
      console.log(val);
      this.id = val;
      if (this.id) {
        this.isDel = true;
      }
    },
    sureDel() {
      console.log(this.id);
      delFamilyRecord(this.id).then((resp) => {
        if (resp.code == 0) {
          this.idEdit = false;
          Toast("删除成功");
          this.getFamilyList();
          // this.id=''
        } else {
          Toast.fail(resp.message);
        }
      });
    },
    cancle() {
      this.vaccId = "";
      this.idEdit=false
    },
    onCancel() {
      this.idEdit = !this.idEdit;
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.refreshing = true;

      // this.onLoad();
      onloadFamily().then((resp) => {
        if (resp.code == 0) {
          fetchFamily().then((resp) => {
            let { data } = resp;
            data.forEach((v) => {
              v.age = computingAge(moment(v.birthDate, "YYYY-MM-DD").valueOf());
              v.sex = v.idCardNo[16] % 2 == 0 ? "女" : "男";
            });
            data = getAgeDesc(data);
            this.list = data;
            const list = data.filter((item) => {
              return (item.verify == 1 && item.isGranted) || (item.relation == '本人' || item.relation == '1')
            });
            this.$store.commit("setFamily", list);
            Toast("刷新成功");
            this.loading = false;
            this.refreshing = false;
            this.idEdit = false;
          });
        }
      });
    },
    onLoad() {},
    onDetail(id) {
      console.log(id);
      this.$router.push({ path: "/record-details", query: { id: id } });
    },
    onCheck() {
      Toast("功能开发中");
    },
    onAdd() {
      this.$router.push("/add-family");
    },
    //二维码
    QRcode(val) {
      console.log(val);
      // getQRcode(val).then(resp=>{
      //   if(resp.code==0){
      //     this.isshow=true
      //     this.profileQrCode=resp.data
      //   }
      // })
      this.isshow = true;
      this.profileQrCode = val;
    },
    //  列表
    getFamilyList() {
      fetchFamily().then((resp) => {
        let { data } = resp;
        data.forEach((v) => {
          v.age = computingAge(moment(v.birthDate, "YYYY-MM-DD").valueOf());
          v.sex = v.idCardNo[16] % 2 == 0 ? "女" : "男";
        });
        data = getAgeDesc(data);
        this.list = data;
        const list = data.filter((item) => {
          return (item.verify == 1 && item.isGranted) || (item.relation == '本人' || item.relation == '1')
        });
        this.$store.commit("setFamily", list);
        this.loading = false;
        this.refreshing = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.family-wrap {
  padding-bottom: 60px;
  .van-dialog,
  .van-dialog .van-dialog__content {
    text-align: center !important;
  }
  width: 100%;
  box-sizing: border-box;

  .content {
    padding: 13px;

    .family {
      width: 100%;
      box-sizing: border-box;
      background-color: #ffffff;
      padding: 0 14px 10px;
      border-radius: 8px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px;

      &.currFamily {
        background-color: #dcdcdc;
      }

      .radiofamily {
        width: 30px;
      }
      .family-right {
        width: calc(100% - 30px);
        box-sizing: border-box;
      }

      .family-top {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 0;

        .codeimg {
          width: 23px;
          height: 23px;
        }

        .topleft {
          width: calc(100% - 23px);
          box-sizing: border-box;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 15px;
          b {
            margin-right: 5px;
          }

          span {
            margin-right: 5px;
            color: #666666;
          }
          .seximg {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
          .imgwoman {
            width: 12px;
            height: 16px;
            margin-right: 5px;
          }
        }
      }
      .listdsc {
        padding-bottom: 15px;
        color: #666666;
      }

      .family-bot {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-top: 10px;
        border-top: 1px solid #eeeeee;

        button {
          width: 80px;
          padding: 0;
          margin-left: 10px;
        }
      }
    }
  }

  .family-list-bottom {
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0px;
    z-index: 10;
    padding: 10px 14px;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>